module.exports = __webpack_public_path__ + "static/media/3s.cdb3f985.png";